import { render, staticRenderFns } from "./channelSuccess.vue?vue&type=template&id=137bf54f&scoped=true"
import script from "./channelSuccess.vue?vue&type=script&lang=js"
export * from "./channelSuccess.vue?vue&type=script&lang=js"
import style0 from "./channelSuccess.vue?vue&type=style&index=0&id=137bf54f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137bf54f",
  null
  
)

export default component.exports